import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    currentUser: undefined,
  },
  reducers: {
    setUsers: (state, { payload: obj }) => {
      state.users = obj;
    },
    setCurrentUser: (state, { payload: obj }) => {
      state.currentUser = obj;
    },
  },
});

export const { setUsers, setCurrentUser } = slice.actions;

export default slice.reducer;

export const selectUsers = (state) => state.users;
